module.exports = __webpack_public_path__ + "static/library-e545e02586f42af6f42e0b34c3bcaec8.jpg";